import { postEditColumns } from '../services';
export const postEditColumnsTable = (metricsAndDimensions, preset, report) => postEditColumns(metricsAndDimensions, preset, report).then(response => formatPostEditColumns(response?.data));
const formatPostEditColumns = (response) => {
    return response?.success;
};
